import {
  renderTypeOf,
  resolveRenderType,
} from './renderRegistry';

const suggestionTextOf = (vehicle = {}) => [
  vehicle.model,
  vehicle.category,
  vehicle.asset_type,
].filter(Boolean).join(' ');

const confidenceOf = (matchedAlias) => {
  const tokenCount = String(matchedAlias || '').trim().split(/\s+/).filter(Boolean).length;
  return tokenCount > 1 ? 'high' : 'medium';
};

/**
 * Produce a setup-only classification suggestion. This function deliberately
 * ignores legacy Vehicle.type and never returns a runtime render identity.
 */
const suggestVehicleClassification = (vehicle, layouts = []) => {
  const source = suggestionTextOf(vehicle);
  if (!source) return null;

  const resolved = resolveRenderType(source);
  if (resolved.source === 'fallback') return null;

  const entry = renderTypeOf(resolved.key);
  if (!entry) return null;

  const candidates = layouts.filter((layout) => layout.vehicle_class?.code === entry.key);
  return {
    classKey: entry.key,
    label: entry.label,
    category: entry.category,
    matchedAlias: resolved.matchedAlias,
    confidence: confidenceOf(resolved.matchedAlias),
    status: candidates.length ? 'review' : 'needs_layout',
    layouts: candidates,
  };
};

export {
  suggestionTextOf,
  suggestVehicleClassification,
};
